import React, { memo } from 'react'
import Tooltip from 'react-wot-bootstrap/lib/components/Tooltip/Tooltip'
import {
    LIMITS,
    LIMITS_DESCRIPTION,
    TASK,
    REWARD,
    REWARD_TAKEN,
    DONE,
    RULE_FULL_DAMAGE,
    RULE_EXP,
    RULE_FRAGS,
} from './translations'
import styles from './ClanSupplyTooltips.scss'
import classNames from 'classnames'
import { QUEST_RULES, QUEST_SQUAD, QUEST_STATUSES } from '../clan_quests_constants'
import PropTypes from 'prop-types'

function getTaskDescription(value, rule, isSoloIncluded) {
    if (rule === QUEST_RULES.FULL_DAMAGE) {
        return RULE_FULL_DAMAGE(value, isSoloIncluded)
    }

    if (rule === QUEST_RULES.EXP) {
        return RULE_EXP(value, isSoloIncluded)
    }

    if (rule === QUEST_RULES.FRAGS) {
        return RULE_FRAGS(value, isSoloIncluded)
    }
}

const ProgressbarTooltip = memo(({
    id,
    rule,
    squadStates,
    isClanSquad,
    value,
    levelFrom,
    levelTo,
    status,
    industrialResource,
    tourCoin,
}) => {
    return (
        <Tooltip
            id={id}
            isWide
        >
            <div className={styles.wrapper}>
                <p className={classNames(styles['tooltip-title'], styles.title)}>
                    {TASK}
                </p>
                <p className={classNames(styles['tooltip-message'], styles.description)}>
                    {getTaskDescription(value, rule, squadStates.includes(QUEST_SQUAD.SOLO))}
                </p>
                <p className={classNames(styles['tooltip-subtitle'], styles.restrictions)}>
                    <span className={styles.infoIcon} />
                    {LIMITS}
                </p>
                <p className={classNames(styles['tooltip-message'], styles.vehicleTier)}>
                    {LIMITS_DESCRIPTION(levelFrom, levelTo, isClanSquad)}
                </p>
                <div className={classNames(styles['tooltip-subtitle'], styles.reward)}>
                    {REWARD}
                    <div className={styles.divider} />
                    <div className={classNames(styles.currency, styles.currency__tourCoin)}>
                        {tourCoin}
                    </div>
                    <div className={styles.iconPlus} />
                    <div className={classNames(styles.currency, styles.currency__industrialResource)}>
                        {industrialResource}
                    </div>
                </div>
                {status !== QUEST_STATUSES.INCOMPLETE && (
                    <p className={styles.done}>
                        {status === QUEST_STATUSES.COMPLETE ?
                            REWARD_TAKEN :
                            DONE
                        }
                    </p>
                )}
            </div>
        </Tooltip>
    )
})

ProgressbarTooltip.propTypes = {
    id: PropTypes.string.isRequired,
    rule: PropTypes.oneOf(Object.values(QUEST_RULES)).isRequired,
    squadStates: PropTypes.arrayOf(PropTypes.oneOf(Object.values(QUEST_SQUAD))).isRequired,
    isClanSquad: PropTypes.bool.isRequired,
    value: PropTypes.number.isRequired,
    levelFrom: PropTypes.number.isRequired,
    levelTo: PropTypes.number.isRequired,
    status: PropTypes.oneOf(Object.values(QUEST_STATUSES)).isRequired,
    industrialResource: PropTypes.number.isRequired,
    tourCoin: PropTypes.number.isRequired,
}

export default ProgressbarTooltip



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/ClanSupplyTooltips/ProgressbarTooltip.jsx